import Login from './pages/login';
import Landing from './pages/landing';
import HomeView from './pages/aluno/home';
import SelectType from './pages/aluno/selectType';
import SelectInstructor from './pages/aluno/selectInstrutor';
import SelectDateAndHour from './pages/aluno/selectDateAndHour';
import Confirm from './pages/confirm';
import End from './pages/end';
import Erro from './pages/erro';
import Perfil from './pages/perfil';
import HomeInstrutor from './pages/instrutor/homeInstrutorView';
import ListAulasInstrutor from './pages/instrutor/listAulasInstrutorView';
import ListAlunosView from './pages/instrutor/listAlunosView';
import SelectVeicle from './pages/aluno/selectVeicle';
import CreateAula from './pages/instrutor/createAula';
import SelectAutoescola from './pages/instrutor/selectAutoescola';
import Register from './pages/aluno/register';
import SelectCreateAula from './pages/instrutor/selectCreateAula';
import CreateAulaWizard from './pages/instrutor/createAulaWizard';

import Layout from './layout/layout';

import { HashRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <HashRouter basename="/">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />

          {/* Home com Layout */}
          <Route
            path="/home"
            element={
              <Layout back="/login" home="">
                <HomeView />
              </Layout>
            }
          />

          <Route
            path="/selecionarTipo"
            element={
              <Layout back="/home" home="/home">
                <SelectType />
              </Layout>
            }
          />

          <Route
            path="/selecionarAutoescola"
            element={
              <Layout>
                <SelectAutoescola />
              </Layout>
            }
          />

          <Route
            path="/selecionarInstrutor"
            element={
              <Layout back="/selecionarTipo" home="/home">
                <SelectInstructor />
              </Layout>
            }
          />

          <Route
            path="/selecionarVeiculo"
            element={
              <Layout back="/selecionarInstrutor" home="/home">
                <SelectVeicle back="/selecionarInstrutor" home="/home" />
              </Layout>
            }
          />

          <Route
            path="/selecionarDataEHora"
            element={
              <Layout back="/selecionarVeiculo" home="/home">
                <SelectDateAndHour />
              </Layout>
            }
          />

          <Route
            path="/confirmar"
            element={
              <Layout back="/selecionarDataEHora" home="/home">
                <Confirm />
              </Layout>
            }
          />

          <Route
            path="/fim"
            element={
              <End />
            }
          />

          <Route
            path="/erro"
            element={
              <Erro />
            }
          />

          <Route
            path="/perfil"
            element={
              <Layout>
                <Perfil />
              </Layout>
            }
          />

          <Route
            path="/register/:id"
            element={<Register />}
          />

          <Route
            path="/register"
            element={<Register />}
          />

          <Route
            path="/homeinstrutor"
            element={
              <Layout back="/login" home="">
                <HomeInstrutor />
              </Layout>
            }
          />

          <Route
            path="/listAulasInstrutor"
            element={
              <Layout back="/homeinstrutor" home="/homeinstrutor" >
                <ListAulasInstrutor />
              </Layout>
            }
          />

          <Route
            path="/listarAlunosInstrutor"
            element={
              <Layout back="/homeinstrutor" home="/homeinstrutor">
                <ListAlunosView />
              </Layout>
            }
          />

          <Route
            path="/selecionarFormaAgendamento"
            element={
              <Layout back="/listarAlunosInstrutor" home="/homeinstrutor">
                <SelectCreateAula />
              </Layout>
            }
          />

          <Route
            path="/criarAula"
            element={
              <Layout back="/listarAlunosInstrutor" home="/homeinstrutor">
                <CreateAulaWizard />
              </Layout>
            }
          />

          <Route
            path="/criarAulaManual"
            element={
              <Layout back="/listarAlunosInstrutor" home="/homeinstrutor">
                <CreateAula />
              </Layout>
            }
          />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
